'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _reactRedux = require('react-redux');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactUtils = require('react-utils');

var _Immutable = require('Immutable');

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UICard = require('UIComponents/card/UICard');

var _UICard2 = _interopRequireDefault(_UICard);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _color = require('MeetingsBase/utils/color');

var _DatePickerButton = require('MeetingsLib/components/schedule/date/DatePickerButton');

var _DatePickerButton2 = _interopRequireDefault(_DatePickerButton);

var _ZeroState = require('MeetingsLib/components/schedule/ZeroState');

var _ZeroState2 = _interopRequireDefault(_ZeroState);

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _TroubleshootingSelectors = require('MeetingsLib/selectors/TroubleshootingSelectors');

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUM_DAYS = 7;
var NUM_WEEKS = 5;
var DAY_RANGE = (0, _Immutable.Range)().take(NUM_DAYS).toArray();

var DatePicker = _React2.default.createClass({
  displayName: 'DatePicker',

  propTypes: {
    // passed
    branding: _React.PropTypes.instanceOf(_Branding2.default).isRequired,
    compact: _React.PropTypes.bool,
    profile: _React.PropTypes.instanceOf(_UserProfile2.default),
    setEventDate: _React.PropTypes.func.isRequired,
    // loaded
    bookableDates: _React.PropTypes.instanceOf(_Immutable.List).isRequired,
    configuredAvailabilityByDate: _React.PropTypes.instanceOf(_Immutable.OrderedMap).isRequired,
    dateOptions: _React.PropTypes.instanceOf(_Immutable.Seq).isRequired,
    editLinkURL: _React.PropTypes.string.isRequired,
    groupedTroubleshotStartTimes: _React.PropTypes.instanceOf(_Immutable.OrderedMap).isRequired,
    minimumNoticeTimeBusyDays: _React.PropTypes.instanceOf(_Immutable.List).isRequired,
    selectedDate: _React.PropTypes.string,
    isFetchingPublicAvailability: _React.PropTypes.bool.isRequired,
    isFetchingPublicGlobalBranding: _React.PropTypes.bool.isRequired,
    userTimezone: _React.PropTypes.string.isRequired
  },

  getInitialState: function getInitialState() {
    return { monthsAhead: 0 };
  },
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        compact = _props.compact,
        selectedDate = _props.selectedDate,
        dateOptions = _props.dateOptions,
        setEventDate = _props.setEventDate;


    if (!compact && !dateOptions.includes(selectedDate)) {
      setEventDate(dateOptions.min());
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _props2 = this.props,
        publicAvailabilityWasLoading = _props2.isFetchingPublicAvailability,
        compact = _props2.compact;
    var publicAvailabilityLoading = nextProps.isFetchingPublicAvailability,
        selectedDate = nextProps.selectedDate,
        dateOptions = nextProps.dateOptions,
        setEventDate = nextProps.setEventDate;


    if (publicAvailabilityWasLoading && !publicAvailabilityLoading) {
      if (!compact && !dateOptions.includes(selectedDate)) {
        setEventDate(dateOptions.min());
      }
    }
  },
  getHeaderClasses: function getHeaderClasses() {
    var compact = this.props.compact;


    return (0, _reactUtils.classNames)('date-picker-header', {
      'm-bottom-4': compact,
      'm-bottom-6': !compact
    });
  },
  getMinimumAvailableDay: function getMinimumAvailableDay() {
    var dateOptions = this.props.dateOptions;

    return _I18n2.default.moment(dateOptions.min());
  },
  getMaximumAvailableDay: function getMaximumAvailableDay() {
    var dateOptions = this.props.dateOptions;

    return _I18n2.default.moment(dateOptions.max());
  },
  getStartOfMonth: function getStartOfMonth() {
    var dateOptions = this.props.dateOptions;
    var monthsAhead = this.state.monthsAhead;

    return _I18n2.default.moment(dateOptions.min()).startOf('month').add(monthsAhead, 'months');
  },
  getEndOfMonth: function getEndOfMonth() {
    var dateOptions = this.props.dateOptions;
    var monthsAhead = this.state.monthsAhead;

    return _I18n2.default.moment(dateOptions.min()).endOf('month').add(monthsAhead, 'months');
  },
  getDaysToShiftForward: function getDaysToShiftForward() {
    // some locales start their week on Monday
    return this.getLocaleData()._week.dow;
  },
  getDaysToShiftBack: function getDaysToShiftBack(dateObject) {
    var daysFromSunday = dateObject.isoWeekday() % 7;
    var daysToShiftForward = this.getDaysToShiftForward();

    /*
    * if the month starts on Sunday and we are in a locale
    * that starts weeks on Monday, we would cut off the first
    * Sunday unless we rendered the entire previous week
    */
    if (daysFromSunday === 0 && daysToShiftForward === 1) {
      return 6;
    }
    return daysFromSunday - daysToShiftForward;
  },
  getStartOfWeek: function getStartOfWeek(dateObject) {
    var daysToShiftBack = this.getDaysToShiftBack(dateObject);
    return dateObject.subtract(daysToShiftBack, 'days');
  },
  getLastDisplayedDay: function getLastDisplayedDay() {
    var startOfWeek = this.getStartOfWeek(this.getStartOfMonth());
    return _I18n2.default.moment(startOfWeek).add({
      days: NUM_DAYS - 1,
      weeks: NUM_WEEKS - 1
    });
  },
  minOrMaxAvailabilityNotDisplayed: function minOrMaxAvailabilityNotDisplayed() {
    var lastDisplayedDay = this.getLastDisplayedDay();
    var lastDayOfMonth = this.getEndOfMonth();
    var minAvailableDay = this.getMinimumAvailableDay();
    var maxAvailableDay = this.getMaximumAvailableDay();

    var availabilityOutsideOfDisplayed = lastDisplayedDay.isBefore(minAvailableDay) || lastDisplayedDay.isBefore(maxAvailableDay);

    return lastDisplayedDay.isBefore(lastDayOfMonth) && availabilityOutsideOfDisplayed;
  },
  getMonthButtonOpacity: function getMonthButtonOpacity(disabled) {
    return disabled ? '0.5' : 1;
  },
  isMinMonth: function isMinMonth() {
    var dateOptions = this.props.dateOptions;

    return _I18n2.default.moment(dateOptions.min()).month() === this.getStartOfMonth().month();
  },
  isMaxMonth: function isMaxMonth() {
    var dateOptions = this.props.dateOptions;

    return _I18n2.default.moment(dateOptions.max()).month() === this.getStartOfMonth().month();
  },
  handleSetEventDate: function handleSetEventDate(date) {
    var _props3 = this.props,
        setEventDate = _props3.setEventDate,
        dateOptions = _props3.dateOptions,
        troubleshooting = _props3.troubleshooting;


    if (troubleshooting || dateOptions.includes(date)) {
      setEventDate(date);
    }
  },
  getPrevMonth: function getPrevMonth() {
    this.setState({ monthsAhead: this.state.monthsAhead - 1 });
  },
  getNextMonth: function getNextMonth() {
    this.setState({ monthsAhead: this.state.monthsAhead + 1 });
  },
  getLocaleData: function getLocaleData() {
    return _I18n2.default.moment.localeData(_I18n2.default.locale) || _I18n2.default.moment.localeData();
  },
  getAbbreviatedWeekdays: function getAbbreviatedWeekdays() {
    return new _Immutable.List(this.getLocaleData()._weekdaysShort);
  },
  getWeekDayNames: function getWeekDayNames() {
    var numDaysToShift = this.getDaysToShiftForward();
    var daysOfWeek = this.getAbbreviatedWeekdays();
    var daysToShift = daysOfWeek.take(numDaysToShift);

    return daysOfWeek.splice(0, numDaysToShift).concat(daysToShift);
  },
  getWeekRange: function getWeekRange(extraWeek) {
    var weeksToRender = extraWeek ? NUM_WEEKS + 1 : NUM_WEEKS;
    return (0, _Immutable.Range)().take(weeksToRender).toArray();
  },
  renderDays: function renderDays(weekNumber) {
    var _this = this;

    var _props4 = this.props,
        bookableDates = _props4.bookableDates,
        branding = _props4.branding,
        configuredAvailabilityByDate = _props4.configuredAvailabilityByDate,
        editLinkURL = _props4.editLinkURL,
        dateOptions = _props4.dateOptions,
        groupedTroubleshotStartTimes = _props4.groupedTroubleshotStartTimes,
        minimumNoticeTimeBusyDays = _props4.minimumNoticeTimeBusyDays,
        selectedDate = _props4.selectedDate,
        troubleshooting = _props4.troubleshooting,
        userTimezone = _props4.userTimezone;

    var startOfWeek = this.getStartOfWeek(this.getStartOfMonth());

    return DAY_RANGE.map(function (daysToAdd) {
      var date = _I18n2.default.moment(startOfWeek).add({ days: daysToAdd, weeks: weekNumber }).format('YYYY-MM-DD');
      return _React2.default.createElement(_DatePickerButton2.default, {
        key: date + '-' + daysToAdd,
        daysToAdd: daysToAdd,
        branding: branding,
        date: date,
        availableDates: dateOptions,
        handleSetEventDate: _this.handleSetEventDate,
        selected: selectedDate === date
        // troubleshoot mode
        , bookableDates: bookableDates,
        configuredAvailabilityByDate: configuredAvailabilityByDate,
        editLinkURL: editLinkURL,
        groupedTroubleshotStartTimes: groupedTroubleshotStartTimes,
        minimumNoticeTimeBusyDays: minimumNoticeTimeBusyDays,
        troubleshooting: troubleshooting,
        userTimezone: userTimezone
      });
    });
  },
  renderWeekDayNames: function renderWeekDayNames() {
    var weekDayNames = this.getWeekDayNames();

    return weekDayNames.map(function (dayName) {
      return _React2.default.createElement(
        _UIBox2.default,
        { key: dayName, grow: 1, shrink: 1, basis: '1%' },
        _React2.default.createElement(
          'h6',
          { className: 'm-bottom-0 m-x-1' },
          dayName
        )
      );
    });
  },
  renderWeeks: function renderWeeks() {
    var _this2 = this;

    var _props5 = this.props,
        compact = _props5.compact,
        dateOptions = _props5.dateOptions,
        profile = _props5.profile,
        isFetchingPublicAvailability = _props5.isFetchingPublicAvailability;


    if (compact && !dateOptions.count() && !isFetchingPublicAvailability) {
      // Render empty state for compact view
      return _React2.default.createElement(
        _UICard2.default,
        { className: 'week-container zero-state' },
        _React2.default.createElement(_ZeroState2.default, { profile: profile, compact: true })
      );
    }

    var extraWeek = this.minOrMaxAvailabilityNotDisplayed();

    return this.getWeekRange(extraWeek).map(function (weeksToAdd) {
      return _React2.default.createElement(
        _UIFlex2.default,
        { key: weeksToAdd, className: 'extraWeek' },
        _this2.renderDays(weeksToAdd)
      );
    });
  },
  renderHeader: function renderHeader() {
    var primaryColor = this.props.branding.primaryColor;


    var isMinMonth = this.isMinMonth();
    var isMaxMonth = this.isMaxMonth();
    var monthBackOpacity = this.getMonthButtonOpacity(isMinMonth);
    var monthForwardOpacity = this.getMonthButtonOpacity(isMaxMonth);
    var textColor = (0, _color.getTextColor)(primaryColor);

    return _React2.default.createElement(
      _UIFlex2.default,
      {
        align: 'center',
        justify: 'around',
        className: this.getHeaderClasses()
      },
      _React2.default.createElement(
        _UIButton2.default,
        {
          use: 'transparent',
          onClick: this.getPrevMonth,
          disabled: isMinMonth
        },
        _React2.default.createElement(_UIIcon2.default, {
          name: icons.LEFT_ARR,
          color: textColor,
          style: { opacity: monthBackOpacity }
        })
      ),
      _React2.default.createElement(
        'h3',
        { className: 'm-bottom-0', style: { minWidth: '80px' } },
        this.getStartOfMonth().format('MMMM')
      ),
      _React2.default.createElement(
        _UIButton2.default,
        {
          use: 'transparent',
          onClick: this.getNextMonth,
          disabled: isMaxMonth
        },
        _React2.default.createElement(_UIIcon2.default, {
          name: icons.RIGHT_ARR,
          color: textColor,
          style: { opacity: monthForwardOpacity }
        })
      )
    );
  },
  render: function render() {
    var compact = this.props.compact;


    var weekDaysClasses = (0, _reactUtils.classNames)('title-case', {
      'm-bottom-4': !compact,
      'm-bottom-2': compact
    });

    return _React2.default.createElement(
      'div',
      { className: 'date-picker width-100 text-center uppercase' },
      this.renderHeader(),
      _React2.default.createElement(
        _UIFlex2.default,
        { className: weekDaysClasses },
        this.renderWeekDayNames()
      ),
      this.renderWeeks()
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,

    bookableDates: (0, _TroubleshootingSelectors.getConfiguredBookableDates)(state),
    configuredAvailabilityByDate: (0, _TroubleshootingSelectors.getConfiguredAvailabilityByDate)(state),
    dateOptions: (0, _BookInfoSelectors.getDateOptions)(state),
    editLinkURL: (0, _BookInfoSelectors.getEditLinkURL)(state),
    groupedTroubleshotStartTimes: (0, _TroubleshootingSelectors.getGroupedTroubleshotStartTimes)(state),
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    isFetchingPublicGlobalBranding: (0, _RequestStatusSelectors.getIsFetchingPublicGlobalBranding)(state),
    minimumNoticeTimeBusyDays: (0, _TroubleshootingSelectors.getMinimumNoticeTimeBusyDays)(state),
    selectedDate: (0, _BookInfoSelectors.getEvent)(state).dateString,
    troubleshooting: (0, _TroubleshootingSelectors.isTroubleshootingSelector)(state),
    userTimezone: (0, _BookInfoSelectors.getUserTimezone)(state)
  };
})(DatePicker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/date/DatePicker.js
// module id = 375
// module chunks = 0